<template>
<div class="description">
  <div class="description__container">

    <product-title :descTitleShow="descTitleShow" >
      {{ descTitle }}
    </product-title>

    <ul class="description__list">
      <check-list v-for="desc in description" :key="desc" :checkListItem="desc" />
    </ul>

  </div>
</div>
</template>

<script>
import CheckList from '@/components/shared/listing/CheckList.vue';
import ProductTitle from '@/components/shared/ProductTitle.vue';

export default {
  props: {
    checkListItem: {
      type: Object,
      default() {
        return {};
      },
    },
    description: {
      type: Array,
      required: true,
    },
    descTitle: {
      type: String,
      default() {
        return '';
      },
    },
    subtext: {
      type: String,
      default() {
        return '';
      },
    },
    descTitleShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  components: {
    CheckList,
    ProductTitle,
  },
};
</script>

<style lang="scss" scoped>
$light-gray: #D5D6D7;
$orange: #F8A81B;

.description {
  position: relative;
  z-index: 20;
  &__container {
    padding: 40px 180px;
    margin: 0 auto;
    max-width: 1600px;

    @media (max-width: 1275px) {
      padding: 40PX 50px;
    }

    @media (max-width: 480px) {
      padding: 30px;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
